import { render } from "./DarkMode.vue?vue&type=template&id=061fdac8&scoped=true"
import script from "./DarkMode.vue?vue&type=script&lang=js"
export * from "./DarkMode.vue?vue&type=script&lang=js"

import "./DarkMode.vue?vue&type=style&index=0&id=061fdac8&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061fdac8"]])

export default __exports__